import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ISupplierInboxJob } from '../../../interfaces/inbox-job';
import { JobRejectionReasonService } from '../../../services/job-rejection/job-rejection-reasons.service';
import { JobRejectionReasonDTO } from '../../../interfaces/job-rejection/job-rejection-reason.dto.interface';
import { SupplierInboxJobsService } from 'src/app/services/supplier-inbox-jobs.service';
import { MessageService } from 'primeng';
import { SupplierJobInteractionService, UserService } from '../../../services';
import { InputHelper } from '../../../utils/input.helper';
import { RejectJobWithReasonDTO } from '../../../interfaces/job-rejection/reject-job-with-reason.dto.interface';
import { JobAnalyticsService } from '../../../services/product-analytics/job-analytics.service';
import { result } from 'lodash';
import { ImpersonationInfo } from 'src/app/interfaces/user';

@Component({
  selector: 'hide-job-dialog',
  templateUrl: './hide-job-dialog.component.html',
  styleUrls: ['./hide-job-dialog.component.scss'],
})
export class HideJobDialogComponent implements OnInit {
  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() jobHidden: EventEmitter<number> = new EventEmitter<number>();

  @Input() job: ISupplierInboxJob;

  hideReasons: JobRejectionReasonDTO[];

  hideReason: JobRejectionReasonDTO;

  hideText: string;

  isUserImpersonate = false;
  impersonatedUserGUID: string;

  constructor(
    private jobRejectionReasonService: JobRejectionReasonService,
    private supplierInboxJobsService: SupplierInboxJobsService,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    private supplierJobInteractionService: SupplierJobInteractionService,
    private jobAnalyticsService: JobAnalyticsService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.userService.isUserImpersonating().then((res) => {
      var resultData: ImpersonationInfo;
      resultData = res;
      if (resultData != null) {
        this.isUserImpersonate = resultData.isImpersonating;
        this.impersonatedUserGUID = resultData.isImpersonating
          ? resultData.impersonatedUserGUID
          : resultData.originalUserId;
      }
    });
  }

  rejectJob() {
    this.supplierJobInteractionService.logSingleJobInteraction('RejectJobAttempt', this.job.id, {});

    const dto = <RejectJobWithReasonDTO>{
      jobId: this.job.id,
      rejectionReasonId: this.hideReason.id,
      reasonText: this.hideText,
    };

    this.supplierInboxJobsService.rejectJobWithReason(dto).then(() => {
      const registrationNumber = this.job.tasks.reduce(
        (sum, t) => sum + ' ' + t.vehicle?.registrationNumber,
        '',
      );
      this.jobAnalyticsService.sendHideJobEvent(
        this.job.id,
        registrationNumber,
        this.hideReason.reason,
        this.hideText,
      );
      this.jobHidden.emit(dto.jobId);
      this.visibleChange.emit(false);
      this.supplierJobInteractionService.logSingleJobInteraction(
        'RejectJobSuccess',
        this.job.id,
        {},
      );
    });
  }

  onShow() {
    this.hideReason = null;
    this.hideText = null;
    this.jobRejectionReasonService.getJobRejectionReasons().then((res) => {
      this.hideReasons = res;
    });
  }
}
